var app = angular.module("leonardo");

var TemplateCalendarFilters = function(
  $scope,
  $controller,
  TemplateService,
  CategoryCacheRestService,
  SectorRestService,
  ClientInstanceService
) {

$controller('FiltersBaseController', { $scope: $scope });
if (!$scope.filterService.hasFilter('property_reports') && $scope.filterService.currentProperty) {
  $scope.filterService.setFilter('property_reports', $scope.filterService.currentProperty.id, true);
}

const clientInstanceOptions = ClientInstanceService.getlist({ essential: true }).then(function (response) {
  return response.map(function (clientInstance) {
    return {
      id: clientInstance.id,
      name: `${clientInstance.name} (id: ${clientInstance.id})`
    };
  });
});

$scope.categories = [];

CategoryCacheRestService.getCategories().then(function(response) {

  if (response && response.length > 0) {
    $scope.categories = response.map(function(category) {
      return { id: category.id, name: category.name }; 
    });
  } else {
    console.warn('No categories found or invalid response');
    $scope.categories = []; 
  }
}, function(error) {
  console.error('Failed to fetch categories:', error);
  $scope.categories = []; 
});

$scope.$watch('categories', function(newValue) {
  if (newValue.length > 0) {
    const categoryFilter = $scope.filters_options.find(option => option.id === 'category');
    if (categoryFilter) {
      categoryFilter.options = newValue;
    }
  }
});

  $scope.templateTypes = [];

  angular.forEach(TemplateService.TYPE_OPTIONS, function(type){
    if ((type.id !== TemplateService.TYPE_SYSTEM_WORKFLOW) && (type.id !== TemplateService.TYPE_ACCOUNT_WORKFLOW)) {
      $scope.templateTypes.push(type);
    }
  });

  $scope.templateStatus = [
    { id: TemplateService.STATUS_PUBLISHED, name: 'Published' },
    { id: TemplateService.STATUS_UNPUBLISHED, name: 'Unpublished' }
  ];

  $scope.noviceOptions = [
    { id: '1', name: 'Novice' },
    { id: '0', name: 'Regular' }
  ];

  var filters = $scope.filterService.hasFilter('filters') ? $scope.filterService.getFilter('filters') : [];

  if (!angular.isArray(filters)) {
    filters = filters.split(',');
  }

  if(!$scope.filterService.hasFilter('status')) {
    $scope.filterService.setFilter('status', TemplateService.STATUS_PUBLISHED);
  }
  if (!_.contains(filters,'status')) {
    filters.push('status');
  }

  $scope.filterService.setFilter('filters', filters);

  $scope.filters_options = [
    {
      group: 'hierarchy',
      name: 'By Hierarchy',
      elements: [
        {
          id: 'client_instances',
          name: 'Client Instance',
          label: null,
          inline: false,
          type: 'options',
          multiple: true,
          required: false,
          placeholder: 'All Client Instances',
          condition: $scope.authDataService.isAdmin(),
          options: clientInstanceOptions,
          conflicts: ['account_reports', 'property_reports', 'portfolio_reports', 'group_reports', 'managed_by_reports']
        },
        {
          id: 'account_reports',
          name: 'Account',
          label: null,
          inline: false,
          type: 'options',
          multiple: true,
          placeholder: 'All Accounts',
          condition: $scope.authDataService.isNotStaff() && $scope.filterService.accounts.length > 1,
          options: $scope.filterService.accounts,
          conflicts: ['client_instances', 'property_reports', 'portfolio_reports', 'group_reports', 'managed_by_reports']
        },
        {
          id: 'group_reports',
          name: 'Property Group',
          label: null,
          inline: false,
          type: 'options',
          multiple: true,
          placeholder: 'All Groups',
          condition: $scope.authDataService.isNotStaff() && $scope.filterService.groups.length > 1 && !$scope.only_account,
          options: $scope.filterService.groups,
          conflicts: ['client_instances', 'property_reports', 'portfolio_reports', 'managed_by_reports', 'account_reports']
        },
        {
          id: 'portfolio_reports',
          name: 'Portfolio',
          label: null,
          inline: false,
          type: 'options',
          multiple: true,
          placeholder: 'All Portfolios',
          condition: $scope.authDataService.isNotStaff() && $scope.filterService.portfolios.length > 1 && !$scope.only_account,
          options: $scope.filterService.portfolios,
          conflicts: ['client_instances', 'property_reports', 'group_reports', 'managed_by_reports', 'account_reports']
        },
        {
          id: 'property_reports',
          name: 'Property',
          label: null,
          inline: false,
          type: 'property_selector',
          multiple: true,
          placeholder: 'All Properties',
          condition: $scope.authDataService.isNotStaff() && $scope.filterService.properties.length > 1 && !$scope.only_account,
          options: $scope.filterService.properties,
          conflicts: ['client_instances', 'portfolio_reports', 'group_reports', 'managed_by_reports', 'account_reports']
        }
      ]
    },
    {
      id: 'sector',
      name: 'Sector',
      label: null,
      inline: false,
      type: 'options',
      multiple: false,
      placeholder: 'Select sector',
      condition: ($scope.authDataService.isAdmin() || $scope.authDataService.isWhiteLabelAdmin()),
      service: SectorRestService,
      conflicts: ['category']
    },
    {
      id: 'status',
      name: 'Template Status',
      label: null,
      inline: false,
      type: 'options',
      multiple: true,
      placeholder: 'All Status',
      condition: true,
      options: $scope.templateStatus,
      conflicts: []
    },
    {
      id: 'type',
      name: 'Template Type',
      label: null,
      inline: false,
      type: 'options',
      multiple: true,
      placeholder: 'All Types',
      condition: $scope.authDataService.isNotStaff(),
      options: $scope.templateTypes,
      conflicts: []
    },
    {
      id: 'category',
      name: 'Category',
      label: null,
      inline: false,
      type: 'options',
      multiple: true,
      placeholder: 'All Categories',
      options:$scope.categories,
      condition: true,
      
      conflicts: ['sector']
    },
    {
      id: 'novice',
      name: 'Novice',
      label: null,
      inline: false,
      type: 'options',
      multiple: false,
      placeholder: 'All Options',
      condition: true,
      options: $scope.noviceOptions,
      conflicts: []
    }
  ];

  $scope.filterService.showFilters(['property_reports']);

};

app.controller('TemplateCalendarFilters', [
  '$scope',
  '$controller',
  'TemplateService',
  'CategoryCacheRestService',
  'SectorRestService',
  'ClientInstanceService',
  TemplateCalendarFilters
]);
 